import { catalogNameForCode } from 'data-layer-cr/dist/functions/catalogs';
import { GeneralCatalogItem } from 'data-layer-cr/dist/models';

import EmissionDataFields from '../../../../helperTypes/EmissionDataFields';
import { FinancingInformation } from '../../../EmissionRequest';

export default function makeFinancingInformation(
  dataFields: EmissionDataFields,
  bankList: GeneralCatalogItem[],
): FinancingInformation {
  return {
    financingType: dataFields.creditorType,
    creditor: dataFields.currentBank,
    creditorDescription: catalogNameForCode(bankList, dataFields.currentBank),
    creditAmount: Number(dataFields.creditAmount),
  };
}
